import { trackEvent } from '../util/analytics'

up.compiler('[data-track-event]', (element: HTMLElement) => {
  const { name, data, requiresVisible } = up.element.jsonAttr(element, 'data-track-event') as {
    name: string
    data: Record<string, unknown>
    requiresVisible?: boolean
  }
  if (!requiresVisible || (element.parentElement && element.parentElement.offsetParent)) {
    trackEvent(name, data)
  }
})
